import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { formatMoney, getInlineLoader } from "../Helpers";
import { MdAssignmentAdd, MdLocationPin, MdNoteAdd, MdStar } from "react-icons/md";
import MobileInterface from "../MobileInterface";
import logo from '../assets/logo.png';
import { FaDonate, FaListUl, FaRegCreditCard, FaRegListAlt, FaRegUser } from "react-icons/fa";
import { PiHandDepositFill, PiMoneyWavy } from "react-icons/pi";
import { IoIosCart } from "react-icons/io";
import { RiBilibiliLine, RiBillLine, RiMessage2Line } from "react-icons/ri";
import { FaArrowsDownToPeople, FaMoneyBills, FaMoneyBillTrendUp, FaPeopleRoof } from "react-icons/fa6";
import {
  STR_CREATE_POST,
  STR_DONATIONS,
  STR_FLOAT_LOAN_SERVICE,
  STR_INBOX,
  STR_MENU_MY_PURCHASES,
  STR_MENU_MY_SALES,
  STR_MENU_POST_CROPS,
  STR_NEARBY_AGENTS,
  STR_NEARBY_SUPER_AGENTS,
  STR_PASTORS,
  STR_POST_ITEM,
  STR_REPORT_ANALYSIS,
  STR_REQUEST_CASH,
  STR_REQUEST_FLOAT,
  STR_REQUEST_FLOAT_CASH,
  STR_REQUESTS_FEED
} from "../Strings";
import { BsFillPeopleFill } from "react-icons/bs";

export default function HomeMenu() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  const tileStyle = {
    background: "var(--surfaceColor)",
    borderRadius: "18px",
    padding: "18px 10px",
    boxShadow: "var(--shadow3)",
    cursor: "pointer",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    textAlign: "center"
  };

  const iconWrapperStyle = {
    width: 56,
    height: 56,
    borderRadius: "50%",
    background: "rgba(0,0,0,0.05)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto"
  };

  const titleStyle = {
    fontSize: "13px",
    fontWeight: 600,
    marginTop: "10px",
    lineHeight: "1.2",
    textAlign: "center",
  };

  function Tile({ icon, title, onClick }) {
    return (
      <div className="col-4 mb-4">
        <div
          style={tileStyle}
          onClick={onClick}
          onMouseDown={e => e.currentTarget.style.transform = "scale(0.96)"}
          onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
        >
          <div style={iconWrapperStyle}>
            {icon}
          </div>
          <div className="font-semi-bold" style={titleStyle}>
            {title}
          </div>
        </div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="row" style={{ marginTop: 30, marginBottom: 20 }}>

      <Tile
        icon={<MdNoteAdd size={32} color="var(--primaryColor)" />}
        title={STR_CREATE_POST[appContext.language]}
        onClick={() => appContext.navTo({ item: 'view', subItem: 'create-post' })}
      />

      <Tile
        icon={<FaDonate size={32} color="var(--primaryColor)" />}
        title={STR_DONATIONS[appContext.language]}
        onClick={() => appContext.navTo({ item: 'view', subItem: 'donation-form' })}
      />

      <Tile
        icon={<BsFillPeopleFill size={32} color="var(--primaryColor)" />}
        title={STR_PASTORS[appContext.language]}
        onClick={() => appContext.navTo({ item: 'pastors' })}
      />

    </div>
  );
}
